export const iconFontAwesomeShapesBurst = (
	<i className="fa-solid fa-burst"></i>
);
